<template>
  <div>
    <!-- Navbar -->
    <nav class="navbar navbar-expand-lg navbar-light bg-white">
      <!-- Container wrapper -->
      <div class="container-fluid">
        <!-- Toggle button -->
        <button
            class="navbar-toggler"
            :class="{ 'collapsed' : collapsed }"
            @click.prevent="collapsed =  !collapsed"
            type="button"
            :aria-expanded="collapsed"
            aria-label="Toggle navigation"
        >
          <i class="fas fa-bars"></i>
        </button>

        <!-- Collapsible wrapper -->
        <div class="collapse navbar-collapse" :class="{'show' : collapsed}" id="navbarSupportedContent">
          <!-- Navbar brand -->
          <a class="navbar-brand mt-2 mt-lg-0 d-none" href="#">
            <img
                :src="require('@/assets/west-house-logo.png')"
                height="15"
                alt=""
                loading="lazy"
            />
          </a>
          <!-- Left links -->
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item">
              <router-link :to="{name: 'LandingPage'}" class="nav-link">Start</router-link>
            </li>
            <li class="nav-item">
              <a href="#"  class="nav-link" @click.prevent="$i18n.locale = $i18n.locale === 'en' ? 'de' : 'en'">{{ $i18n.locale === 'en' ? 'DE' : 'EN' }}</a>
            </li>
          </ul>
          <!-- Left links -->
        </div>
        <!-- Collapsible wrapper -->

        <!-- Right elements -->
        <div class="d-flex align-items-center">
          <!-- Avatar -->
          <a
              class="d-flex align-items-center hidden-arrow"
              href="#"
              id="navbarDropdownMenuLink"
              role="button"
              aria-expanded="false"
              @click.prevent="$router.push({name: 'LandingPage'})"
          >
            <img
                :src="require('@/assets/west-house-logo.png')"
                height="50"
                alt=""
                loading="lazy"
            />
          </a>
        </div>
        <!-- Right elements -->
      </div>
      <!-- Container wrapper -->
    </nav>
    <!-- Navbar -->
  </div>
</template>

<script>
import {
  mdbNavbar,
  mdbNavbarBrand,
  mdbNavbarToggler,
  mdbNavbarNav,
  mdbNavItem

} from "mdbvue"

export default {
  name: "Navigation",
  data: () => ({ collapsed: false }),
  components:{
    mdbNavbar,
    mdbNavItem,
    mdbNavbarNav,
    mdbNavbarToggler,
    mdbNavbarBrand
  }
}
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/partials/Navigation.vue